import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { RelationCustomFieldConfig } from "@vendure/common/lib/generated-types";
import {
  FormInputComponent,
  DataService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  switchMap,
  catchError,
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { Observable, of, Subject, concat, tap } from "rxjs";
import {
  GetProductTypesDocument,
  SortOrder,
} from "../generated-graphql/graphql";

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./product-type-dropdown.component.html",
})
export class ProductTypeDropdownComponent
  implements OnInit, FormInputComponent<RelationCustomFieldConfig>
{
  constructor(
    private dataService: DataService,
    private route: ActivatedRoute
  ) {}

  productTypes$: Observable<any[]>;

  isListInput?: boolean | undefined = false;
  readonly: boolean;
  formControl: FormControl<any>;
  config: RelationCustomFieldConfig;

  input$ = new Subject<string>();
  isLoading = false;
  ngOnInit(): void {
    const productType = this.formControl.setValidators([Validators.required]);
    // this.productTypes$ = this.dataService
    //   .query(GetProductTypesDocument)
    //   .mapSingle(({ productTypes }) => productTypes?.items ?? []);

    this.productTypes$ = concat(
      this.dataService
        .query(GetProductTypesDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
        })
        .mapSingle(({ productTypes }) => productTypes?.items ?? []),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap((term) => {
          return this.dataService
            .query(GetProductTypesDocument, {
              options: {
                filter:
                  term && term.length > 0
                    ? {
                        name: {
                          contains: term,
                        },
                      }
                    : undefined,
                take: 10,
                sort: {
                  createdAt: SortOrder.Desc,
                },
              },
            })
            .mapStream(({ productTypes }) => productTypes.items)
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => (this.isLoading = false))
            );
        })
      )
    );
  }

  compareFn(item1: { id: string } | null, item2: { id: string } | null) {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  trackByFn(item: { id: any }) {
    return item.id;
  }
}
